class InfiniteScroll {
  constructor() {
    this.grid = document.getElementById('product-grid') || document.querySelector('.blog-articles');
    this.loadMoreBtn = document.getElementById('load-more-btn');
    if (!this.grid || !this.loadMoreBtn) {
      return;
    }
    this.currentPage = parseInt(this.grid.dataset.currentPage);
    this.totalPages = parseInt(this.grid.dataset.totalPages);
    this.isLoading = false;
    // Always use window.location.pathname + window.location.search, fallback to pathname if search is empty
    this.currentUrl = window.location.pathname + (window.location.search || '');

    this.init();
  }

  init() {
    if (!this.grid) return;
    this.bindLoadMore();
    this.bindFilterEvents();
    this.updateLoadMoreBtn();
  }

  bindLoadMore() {
    if (this.loadMoreBtn) {
      if (this._loadMoreHandler) {
        this.loadMoreBtn.removeEventListener('click', this._loadMoreHandler);
      }
      this._loadMoreHandler = this.loadMoreProducts.bind(this);
      this.loadMoreBtn.addEventListener('click', this._loadMoreHandler);
    }
  }

  bindFilterEvents() {
    // Listen for filter form submissions
    const filterForms = document.querySelectorAll('.facets-form, [data-filter-form]');
    filterForms.forEach(form => {
      form.addEventListener('submit', () => {
        
        this.handleFilterChange();
      });
    });

    // Listen for sort changes
    const sortSelect = document.querySelector('[data-sort-by], .sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        this.handleFilterChange();
      });
    }

    // Listen for facet clicks (Dawn theme specific)
    document.addEventListener('click', (e) => {
      if (e.target.matches('.facets__item input, .facets__remove')) {
        setTimeout(() => {
          this.handleFilterChange();
        }, 100);
      }
    });

    // Listen for browser back/forward
    window.addEventListener('popstate', () => {
      this.handleFilterChange();
    });
  }

  handleFilterChange() {
    this.currentPage = 1;
    this.isLoading = false;
    // Always use latest URL, fallback to pathname if search is empty
    this.currentUrl = window.location.pathname + (window.location.search || '');
    setTimeout(() => {
      this.updateGridData();
      this.updateLoadMoreBtn();
      this.bindLoadMore();
    }, 500);
  }

  updateGridData() {
    const newGrid = document.getElementById('product-grid') || document.querySelector('.blog-articles');
    if (newGrid) {
      this.grid = newGrid;
      this.currentPage = parseInt(this.grid.dataset.currentPage || 1);
      this.totalPages = parseInt(this.grid.dataset.totalPages || 1);
    }
    this.loadMoreBtn = document.getElementById('load-more-btn');
    this.bindLoadMore();
  }

  updateLoadMoreBtn() {
    if (this.hasMorePages() && this.loadMoreBtn) {
      this.loadMoreBtn.style.display = '';
    } else if (this.loadMoreBtn) {
      this.loadMoreBtn.style.display = 'none';
    }
  }

  hasMorePages() {
    return this.currentPage < this.totalPages;
  }

  async loadMoreProducts() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.loadMoreBtn.disabled = true;
    this.loadMoreBtn.textContent = 'Loading...';

    try {
      const nextPage = this.currentPage + 1;
      // Use the stored currentUrl, fallback to pathname if empty
      let url = new URL(this.currentUrl || window.location.pathname, window.location.origin);
      url.searchParams.set('page', nextPage);

      const response = await fetch(url.toString());
      const html = await response.text();

      const newProducts = this.extractProducts(html);

      if (newProducts.length > 0) {
        this.appendNewGridItems(newProducts);
        this.currentPage = nextPage;
        this.updateTotalPagesFromResponse(html);
        this.updateLoadMoreBtn();
      } else {
        this.loadMoreBtn.style.display = 'none';
      }
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      this.isLoading = false;
      this.loadMoreBtn.disabled = false;
      this.loadMoreBtn.textContent = 'Load More';
    }
  }

  extractProducts(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const products = doc.querySelectorAll('#product-grid .grid__item');
    const articles = doc.querySelectorAll('.blog-articles .blog-articles__article');
    if (products.length > 0) {
      
      return Array.from(products);
    } else if (articles.length > 0) {
      
      return Array.from(articles);
    }
    
    return [];
  }

  appendNewGridItems(gridItems) {
    const fragment = document.createDocumentFragment();
    gridItems.forEach(item => {
      fragment.appendChild(item.cloneNode(true));
    });
    this.grid.appendChild(fragment);
  }

  updateTotalPagesFromResponse(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const gridData = doc.getElementById('product-grid');
    
    if (gridData && gridData.dataset.totalPages) {
      this.totalPages = parseInt(gridData.dataset.totalPages);
      
    }
  }

  destroy() {
    if (this.loadMoreBtn && this._loadMoreHandler) {
      this.loadMoreBtn.removeEventListener('click', this._loadMoreHandler);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  
  window.infiniteScroll = new InfiniteScroll();
});

// Reinitialize on page changes (for themes that use AJAX navigation)
document.addEventListener('shopify:section:load', () => {
  
  if (window.infiniteScroll) {
    window.infiniteScroll.destroy();
  }
  window.infiniteScroll = new InfiniteScroll();
});